import styled from "@emotion/styled";
import { Box } from "@mui/material";
import theme from "../../theme";
import { ReactNode, useRef } from "react";

type Prop = {
  defaultInfo: ReactNode; // 기본 정보 (상시 노출)
  icons?: ReactNode; // 기본 정보 오른쪽에 표출될 아이콘
  detailInfo?: ReactNode; // 상세 정보 (클릭 시 노출)
  defaultInfoGap?: string;
};

export const MobileTable = ({
  defaultInfo,
  icons,
  detailInfo,
  defaultInfoGap,
}: Prop) => {
  const listWrapperRef = useRef<HTMLDivElement>(null);
  return (
    <ListWrapper ref={listWrapperRef}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          backgroundColor: theme.color.white,
          borderRadius: "5px",
          padding: "12px 16px",
          // gap: "6px",
        }}
      >
        {/* 기본 정보 */}
        <Box
          sx={{
            display: "flex",
            gap: defaultInfoGap ? defaultInfoGap : "16px",
            flexGrow: 1,
          }}
        >
          {/* 왼쪽 영역 */}
          <div
            onClick={() => {
              if (!detailInfo) return;
              // e.currentTarget.classList.toggle("visible");
              listWrapperRef.current?.classList.toggle("visible");
            }}
            style={{
              flexGrow: 1,
              display: "flex",
              gap: "8px",
              flexDirection: "column",
              maxWidth: `calc(100vw - 32px - 32px)`,
            }}
          >
            {defaultInfo}
          </div>
          {/* 아이콘 영역 */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {icons}
          </Box>
        </Box>
        {/* 상세 정보 */}
        <div className="visible-div">{detailInfo}</div>
      </Box>
    </ListWrapper>
  );
};

const ListWrapper = styled.div`
  .visible-div {
    min-height: 0px;
    max-height: 0px;
    overflow: hidden;
    transition: 200ms;
  }

  &.visible {
    .visible-div {
      min-height: auto;
      max-height: 300px;
      width: 100%;
      overflow: visible;
      transition: 200ms;
      margin-top: 6px;
    }
  }
`;
